import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const AIGenerationLimitDialog = ({ open, onClose, featureName = "AI feature", goToUpgrade }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                <Box display="flex" alignItems="center" gap={1}>
                    <WarningAmberIcon color="warning" />
                    <Typography variant="h6" fontWeight="bold">
                        Trial Limit Reached
                    </Typography>
                </Box>
            </DialogTitle>

            <DialogContent>
                <Typography variant="body1" sx={{ mb: 1 }}>
                    You've reached your trial limit for <strong>{featureName}</strong>.
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Upgrade to a premium plan for unlimited access to this feature and more.
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} variant="outlined" color="primary">
                    Close
                </Button>
                <Button
                    onClick={() => {
                        onClose();
                        if (typeof goToUpgrade === "function") {
                            goToUpgrade();
                        }
                    }}
                    variant="contained"
                    color="secondary"
                >
                    Upgrade Now
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AIGenerationLimitDialog;
